// extracted by mini-css-extract-plugin
export default {"Input":"Input_Input__8hdy0","Label":"Input_Label__hxAgH","InputElement":"Input_InputElement__lS-uv","Invalid":"Input_Invalid__02WcZ"};